module.exports = __webpack_public_path__ + "static/img/6.ccaa137.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/zh/6.png
// module id = siyR
// module chunks = 0